/** @jsx jsx */
/* eslint-disable no-use-before-define */   
import { css, jsx } from '@emotion/core'
import { publish, fmt } from '../../twd'
import { getIcon } from './chart-shapes'

const listCss = css `
    div {
        display: grid;
        grid-template-columns: auto 1fr;
    }
    dt, dd {
        padding: 6px;
        line-height: 1.4;
        font-weight:400;
        color: #242424;
        border-bottom: 1px solid #e4e4e4;
        white-space: nowrap;
    }
    dt {
        text-align: left;
    }
    dd {
        text-align: right;
        font-weight: 500;
    }
`

const onMouseOver = (payload, _, event) => {
    const { tradeDateTime, tradePrice, tradeYield, tradeType } = payload

    publish('show_flyout', {
        el:event.target,
        showIcon: false,
        html: 
            <div className="row vertical-offset-sm">
            <dl css={listCss}>
            <div className="col-md-12">
                <dt>Trade Date</dt>
                <dd>{fmt.mdy(tradeDateTime)}</dd>
                <dt>Price</dt>
                <dd>{fmt.price3(tradePrice)}</dd>
                <dt>Yield</dt>
                <dd>{fmt.ytw3(tradeYield)}</dd>
                <dt>Trade Type</dt>
                <dd><span style={{marginRight: '5px'}}>{getIcon(tradeType)}</span> {tradeType}</dd>
            </div></dl>
            </div>
    })
}

export const ChartTooltip = {
    onMouseOver,
}


// WEBPACK FOOTER //
// ./src/trade-history/history/chart-tooltip.js